import st from "@/styles/ApplyCredit.module.scss";
import {TextField} from "@mui/material";
import {textfield_sx} from "@/utils/mui_sx.ts";
import CommonClass from "@/utils/common.ts";
import {country_code, promocode_enabled} from "@/utils/constants.ts";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import Button from "@/ui/Button.tsx";
import React, {useEffect, useRef, useState} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import {LocalLanguage, UserType} from "@/types_and_interfaces/types.ts";
import {useTranslation} from "react-i18next";
import auth from "@/hooks/auth.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import ProductInterface from "@/types_and_interfaces/product_interface.ts";
import LoanBodyInterface from "@/types_and_interfaces/loan_body_interface.ts";
import useLoans from "@/hooks/loans.ts";
import {useLocation, useNavigate} from "react-router-dom";
import dayjs from "dayjs";
import LoginLoader from "@/ui/LoginLoader.tsx";
import PaymentMethodSwitcherMain from "@/ui/PaymentMethodsSwitcherMain.tsx";
import PaymentMethodsObjInterface from "@/types_and_interfaces/payment_methods_obj_interface.ts";
import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import CMS from "@/utils/cms.ts";


interface Props {
    initBody: any
    product:ProductInterface
}

const ApplyForm:React.FC<Props> = ({initBody, product}) => {
    const {t, i18n} = useTranslation()
    
    const [formErrors, setFormErrors] = useState({});
    const [openModal, setOpenModal] = useState<boolean>(false)
    // const genData = CMS.general_info
    // const applications_processing_inf = genData && CMS.langAwareFilter(genData, (i18n.language as LocalLanguage)).applications_processing_inf
    const val_ref = useRef<any>({})
    const user_phone = auth().current_user()?.phone
    const user_type: UserType = auth().current_user()?.represented_identity.type || ""
    const user = auth().current_user()
    const verified =  user?.kyc_general_status === "ProcessingSuccess" || user?.auth_type === "ByMPass"
    const [load, set_load] = useState<boolean>(false)
    const [paymentMethod, setPaymentMethod] = useState<keyof PaymentMethodsObjInterface | "">("")
    const phone = (typeof user_phone === "string" && user_phone.length) ?
        CommonClass.formatNumber(user_phone.replace(country_code, "")) :
        initBody.phone || ""
    const navigate = useNavigate()
    const loans_hook = useLoans()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")

    const pep_checkbox = useRef<any>(null);
    const today = new Date();
    const targetDate = new Date('2025-05-29');
    const after25mai = today >= targetDate

    const pepData = CMS.pep


    const paymentMethodHandler = (x:keyof PaymentMethodsObjInterface) => {
        setPaymentMethod(x)
    }
    
    const validate = (e: any) => {
        let errors: any = {};
        let form = new FormData(e.currentTarget)
        
        const name = form.get("name")
        const surname = form.get("surname")
        const idnx = form.get("idnx")
        const birthday = form.get("birthday") || user?.birthday
        let disb_shop:any = ""
        
        if (((typeof name === "string" && !name.length) || !name) && !user?.first_name.length) errors["name"] = t("incomplete_name")
        if ((typeof name === "string" && name.length) && !user?.first_name.length && !CommonClass.isOnlyRomanianOrEnglishChars(name)) errors["name"] = t("anti_rusaofn_err")

        if ((typeof surname === "string" && !surname.length) && !user?.last_name.length) errors["surname"] = t("incomplete_surname")
        if ((typeof surname === "string" && surname.length) && !user?.last_name.length && !CommonClass.isOnlyRomanianOrEnglishChars(surname)) errors["surname"] = t("anti_rusaofn_err")

        if (((typeof idnx === "string" && !idnx.length) || !idnx) && !user?.idnx.length) errors["idnx"] = t("empty_idnp").replace("{{idnx}}", user_type === "PJ" ? "IDNO" : "IDNP")
        if ((typeof idnx === "string" && idnx.length) && !CommonClass.validateIDNX(idnx)?.validate) errors["idnx"] = t("idnx_error").replace("{{idnx}}", user_type === "PJ" ? "IDNO" : "IDNP")
        if (((typeof birthday === "string" && !birthday.length) || !birthday) && !user?.birthday.length) errors["birthday"] = t("incomplete_birthday")
        if ((typeof phone === "string" && !phone.length) || !phone) errors["phone"] = t("error_message")


        if(after25mai && typeof birthday === "string") {
            const [day, month, year] =  birthday?.split('.').map(Number)

            const inputDate = new Date(year, month - 1, day);

            const today = new Date();
            const cutoffDate = new Date(today.getFullYear() - 19, today.getMonth(), today.getDate());

            if (inputDate > cutoffDate) {
                errors["birthday"] = t("birthday_limit").replace("{{limit}}", "19")
            }
        }


        // METHODS VALIDATION
        const refund_bank = form.get("refund_bank")
        const bank = form.get("bank")
        let refund_account = form.get("refund_account")
        let iban_disb_shop = form.get("iban_disb_shop")
        let phone_disb_shop = form.get("phone_disb_shop")
        let identifier = form.get("identifier")

        if(paymentMethod === "bank"){
            if (typeof refund_bank === "string" && !refund_bank.length) errors["refund_bank"] = t("bank_err")
            if ((typeof refund_account === "string" && !refund_account.length) || ((typeof refund_account === "string" && refund_account.length) && !CommonClass.check_iban(refund_account))) {
                errors["refund_account"] = t("refund_account_err")
            } else {
                if(!CommonClass.check_iban_by_bank(refund_account as string, identifier as string)) {
                    errors["refund_account"] = t("iban_not_of_bank_err").replace("{{bank}}", bank as string)
                }
            }
        }
        
        if(paymentMethod === "online_wallet") {
            if (typeof refund_bank === "string" && !refund_bank.length) errors["refund_bank"] = t("bank_err")
            if (typeof refund_account === "string" && !refund_account.length) errors["refund_account"] = t("refund_account_err1")
        }
        
        if(paymentMethod === "bank" || paymentMethod === "online_wallet") {
            if(typeof refund_account === "string" && refund_account.length) {
                
                if(refund_account.length >= 15 && /^[A-Za-z]/.test(refund_account)) {
                    
                    if(!CommonClass.check_iban(refund_account)) {
                        errors["refund_account"] = t("refund_account_err")
                    } else disb_shop = iban_disb_shop || ""
                    
                    if(CommonClass.check_iban(refund_account) && !CommonClass.check_iban_by_bank(refund_account as string, identifier as string)) {
                        errors["refund_account"] = t("iban_not_of_bank_err").replace("{{bank}}", bank as string)
                    }
                    
                } else {
                    if (refund_account.startsWith("373")) {
                        refund_account = refund_account.substring(3);
                        
                    } else if (refund_account.startsWith("+373")) {
                        refund_account = refund_account.substring(4);
                        
                    }
                    if(refund_account.startsWith("0")) {
                        refund_account = refund_account.substring(1);
                    }
                    
                    refund_account = refund_account.replace(/\s+/g, '')
                    
                    if(refund_account.length !== 8) errors["refund_account"] = t("valid_nr_err")
                    
                    refund_account = CommonClass.formatNumber(refund_account)
                    
                    if(!CommonClass.phoneNumberValidate(refund_account)) errors["refund_account"] = t("valid_nr_err")
                    refund_account = "+373" + refund_account.replace(/\s+/g, '')
                    disb_shop = phone_disb_shop || ""
                }
            }
        }
        
        Object.keys(errors).map((k) => {
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", errors[k])
        })
        
        const enabled = !Object.keys(errors).length
        
        function capitalizeFirstLetter(str:any) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
        
        if(enabled) {
            val_ref.current = {
                product_id: String(product.product_id),
                idnx: user?.idnx || idnx,
                birth_date: String(birthday).split('.').reverse().join('-'),
                first_name:user?.first_name || name,
                last_name: user?.last_name|| surname,
                mobile: country_code +  phone.replace(/\s+/g, ''),
                // TODO : add goods_name
                // goods_name: String(product.family),
                goods_name: "-",
                credit_amount: String(product.capital),
                number_of_installments: String(product.months),
                money_transfer_method: paymentMethod === "mia" ? "MIA" : capitalizeFirstLetter(paymentMethod),
                ...(CommonClass.general_settings.is_pep_enabled && {is_not_pep_person: pep_checkbox.current?.checked ? 'false' : 'true'})
            }
            
            if(paymentMethod === "online_wallet" || paymentMethod === "bank") {
                val_ref.current = {
                    ...val_ref.current,
                    refund_bank,
                    refund_account,
                    disb_shop
                }
            }
        }
        
        
        setFormErrors(errors)
        
        if(debug === "true") {
            console.info(val_ref.current)
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "info", "delete debug query to continue")
            return false;
        }
        // return false;
        return enabled;
    };
    
    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        
        if(!user?.phone.length) {
            eventEmitter.emit(CommonClass.ModalEvents.SetPhone, true, phone, t("set_phone_to_continue"))
            return
        }
        
        let fields_enable = validate(e)
        
        if(!fields_enable) return

        if(Object.keys(val_ref.current).length){

            set_load(true)

           let success = await loans_hook.apply_for_loan(val_ref.current as LoanBodyInterface)

            if(success) {
                navigate(DashboardClass.dashboard_routes.SuccessCr)
            }

            set_load(false)
        }
    }
    
    useEffect(() => {
        if(location.pathname) {
            localStorage.setItem(CommonClass.local_storage_fields.prev_path, location.pathname)
        }
    }, [location]);

    return (
        <form onSubmit={onSubmit}>
            {(typeof user === "object" && Object.keys(user).length) ? (
                <>
                    <div className={st.name_fields}>
                        
                        <TextField
                            name={"surname"}
                            label={i18n.language === "ro" ? t("surname") + " (Familia)" : t("surname")}
                            color={"success"}
                            sx={textfield_sx}
                            error={Boolean(formErrors.hasOwnProperty("surname"))}
                            defaultValue={user?.last_name}
                            disabled={Boolean(typeof user?.last_name === "string" && user?.last_name.length)}
                        />
                        
                        <TextField
                            name={"name"}
                            label={t("name")}
                            color={"success"}
                            sx={textfield_sx}
                            error={Boolean(formErrors.hasOwnProperty("name"))}
                            defaultValue={user?.first_name}
                            disabled={Boolean(typeof user?.first_name === "string" && user?.first_name.length)}
                        />
                    
                    </div>
                    
                    <div className={st.phone_number}>
                        <span className={st.phone_label}>
                            {t("phone1")}
                        </span>
                        
                        <span className={st.number}>
                            <span className={st.gray}>
                                {country_code}
                            </span>
                            
                            {phone}
                        </span>
                        
                    </div>
                    
                    <TextField
                        name={"idnx"}
                        label={user_type === "PJ" ? "IDNO" : "IDNP"}
                        error={Boolean(formErrors.hasOwnProperty("idnx"))}
                        color={"success"}
                        sx={textfield_sx}
                        onChange={(e) => {
                            if (e.target.value.length > 13) {
                                e.target.value = e.target.value.slice(0, 13)
                            }
                        }}
                        defaultValue={verified && user?.idnx?.length ? user?.idnx : ""}
                        disabled={verified && Boolean(typeof user?.idnx === "string" && user?.idnx.length)}
                    />

                    <div className={st.birth_date_contaner}>
                        <span className={st.label}>{t("birthday")}</span>
                        {/*TODO : birth date default value*/}
                        
                        <DatePicker
                            {...(user?.birthday ? {defaultValue: dayjs(user?.birthday)} : {})}
                            disableFuture
                            name={"birthday"}
                            sx={textfield_sx}
                            views={['year', 'month', 'day']}
                            disabled={Boolean(user?.birthday)}
                            // defaultValue={user?.birthday ? dayjs(user?.birthday) : dayjs().subtract(18, 'year')}
                            maxDate={dayjs().subtract(after25mai ? 19 : 18, 'year')}
                            slotProps={{
                                textField: {
                                    error: Boolean(formErrors.hasOwnProperty("birthday")),
                                },
                                
                                toolbar: {
                                    toolbarFormat: "DD MMM YYYY"
                                }
                            }}
                        />
                    </div>

                    {CommonClass.general_settings.is_pep_enabled && (
                        <div className={st.checkbox_cont}>
                        <input
                            className={st.checkbox}
                            type={"checkbox"}
                            ref={pep_checkbox}
                            name={"is_not_pep_person"}
                            defaultChecked={false}
                            color="success"
                            onChange={() => {
                                if (!pep_checkbox.current) return
                                pep_checkbox.current.style.outline = 'none'
                                pep_checkbox.current.style.borderRadius = '0'
                            }}
                            style={{ cursor: "pointer" }}

                        />
                        <div>
                            {t('pep_declare')}{" "}
                            <button
                                type={"button"}
                                onClick={()=>setOpenModal(true)}
                                className={st.pep_button}
                            >
                                {t('pep_person')}
                            </button>
                        </div>
                    </div>
                    )}

                    {promocode_enabled && (
                        <TextField
                            name={"promocode"}
                            label={t("promocode")}
                            color={"success"}
                            sx={textfield_sx}
                        />
                    )}
                    
                    {initBody?.type !== "refinance" ? (
                        <PaymentMethodSwitcherMain
                            paymentMethod={paymentMethod as keyof PaymentMethodsObjInterface}
                            paymentMethodHandler={paymentMethodHandler}
                            formErrors={formErrors}
                            initBody={initBody}
                        />
                    ) : null}
                    
                    
                    <div className={st.submit_container}>
                        <Button
                            animated
                            type={"submit"}
                            // disabled={load || !paymentMethod.length}
                            disabled={load || (!paymentMethod.length && initBody?.type !== "refinance")}
                        >
                            <span>{t("send")}</span>
                        </Button>
                        <span>
                            {t("application_timing_approval")}
                        </span>
                    </div>
                </>
            ) : null}
            
            {load && <LoginLoader />}

            <ModalLayout
                className={st.pep_modal}
                open={openModal}
                innerClassName={st.pep_modal_inner}
                on_close_state={() => {
                    setOpenModal(false)
                }}
            >
                {CommonClass.isSafeHtml(pepData[`${i18n.language as LocalLanguage}_content`]) && (
                    <div className={st.content} dangerouslySetInnerHTML={{__html: pepData[`${i18n.language as LocalLanguage}_content`]}}/>
                )}
            </ModalLayout>

        </form>
    )
}







export default ApplyForm